import styled from 'styled-components/macro';

export const FilePlateWrap = styled.div`
  display: flex;
  gap: 16px;
`;

export const FilePlateBox = styled.div<{ isError?: boolean }>`
  background: #ffffff;
  width: 96px;
  height: 96px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 2px solid ${(props) => (props.isError ? `#EA443C` : `rgba(9, 21, 38, 0.35)`)};
  position: relative;
`;

export const FilePlateCloseButton = styled.button`
  background-color: #ffffff;
  width: 24px;
  height: 24px;
  padding: 0;
  margin: 0;
  stroke-width: 2px;
  border-radius: 50%;
  border: rgba(9, 21, 38, 0.35) solid 2px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -8px;
  right: -8px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #f5f5f5;
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 11px;
    height: 0.08rem;
    background-color: #333;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const FileName = styled.span`
  color: rgba(9, 21, 38, 0.85);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  word-break: break-word;
  margin-left: 8px;
  margin-right: 19px;
  white-space: nowrap; /* Запрещаем перенос строк */
  overflow: hidden; /* Обрезаем текст, выходящий за границы */
  text-overflow: ellipsis; /* Добавляем многоточие */
  max-width: 70px;
  box-sizing: border-box;
  display: block;
`;

export const FilePlatePreviewIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorText = styled.span`
  color: #ea443c;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
`;

export const TotalFilesInfo = styled.span`
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const DeleteAllFiles = styled.span`
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  &:hover {
    cursor: pointer;
  }
`;
